// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","toggle_active":"toggle_active-3WC7z","toggle__label":"toggle__label-1JtQ2","switchItem":"switchItem-2zMox"};